import { IconWrapper } from '@flexo/general';
import { useTranslation } from 'react-i18next';

import styles from './../alert.module.scss';

export function AlertWrongSize() {
  const { t } = useTranslation();
  const alertContent = t('alerts.small_size', { returnObjects: true }) as any;

  return (
    <div
      id="banner-wrong-size"
      className={`${styles.Alert} ${styles.Alert__Unexpected__Error}`}
    >
      <div className={styles.Alert__Title__Negative}>
        <div style={{ display: 'flex' }} className={styles.Alert__Title__Wrapper}>
          <div>
            <IconWrapper iconName="alert" />
          </div>
          <div>{alertContent.title}</div>
        </div>
      </div>
      <div className={`paragraph ${styles.Alert__Content}` } style={{ marginBottom: '0px'}}>
        {alertContent.message} {}
      </div>
    </div>
  );
}

export default AlertWrongSize;
